import { engineComponent } from "neo-common";
import { HtmlElement } from "./HtmlElement";
import { ComponentTypes } from "../../Components/ComponentTypes";

/**
 * The html text is used for render text in html.
 * Example:
 *   <span Class="HtmlText">Text</span>
 *
 * @class HtmlText
 * @extends HtmlElement
 */
@engineComponent(ComponentTypes.HtmlElement)
export class HtmlText extends HtmlElement {
    private _prefix: string;

    constructor() {
        super("");
    }

    /**
     * Get attributes from xml and set up supported properties.
     * @method create
     * @param node is Element from xml
     * @retutn void
     */
    create(node: Element): void {
        this.instance = document.createElement(node.nodeName);

        if (node.textContent != null) {
            this.instance.textContent = node.textContent;
        }

        if (node.hasAttribute("Prefix")) {
            this._prefix = node.getAttribute("Prefix");
        }

        /*
         * Test is html data attribute for automated testing support.
         * @property Test
         * @type string
         * @default null
         */
        if (node.hasAttribute("Test")) {
            this.instance.dataset["test"] = node.getAttribute("Test");
        }

        super.create(node);
    }

    setText(value?: string): void {
        super.setText(value);

        if (this._prefix != null && this.instance.innerHTML != null && this.instance.innerHTML != "") {
            this.instance.innerHTML = "+" + this.instance.innerHTML;
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/HTMLComponents/Elements/HtmlText.ts
 **/